module.exports = __webpack_public_path__ + "img/jpeg.ac735bb8.svg";